
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/[slug]",
      function () {
        return require("private-next-pages/industries/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/[slug]"])
      });
    }
  